var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnSocialInstagram = function SvgBtnSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "btn-social-instagram_svg__a",
    d: "M0 0h50v50H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "btn-social-instagram_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn-social-instagram_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#btn-social-instagram_svg__b)",
      fill: "currentColor"
    },
    d: "M34.23 25A9.23 9.23 0 0 1 25 34.23c-5.098 0-9.232-4.133-9.232-9.23 0-.799.115-1.57.305-2.309h-2.611v12.695c0 .635.516 1.15 1.154 1.15h20.77c.639 0 1.154-.516 1.154-1.15V22.691h-2.611c.19.739.301 1.51.301 2.309z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#btn-social-instagram_svg__b)",
      fill: "currentColor"
    },
    cx: 25,
    cy: 25,
    r: 5.769
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#btn-social-instagram_svg__b)",
      fill: "currentColor"
    },
    d: "M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0zm15 36.537A3.46 3.46 0 0 1 36.539 40H13.461A3.46 3.46 0 0 1 10 36.537V13.461A3.46 3.46 0 0 1 13.461 10h23.078A3.46 3.46 0 0 1 40 13.461v23.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#btn-social-instagram_svg__b)",
      fill: "currentColor"
    },
    d: "M35.385 13.461h-3.459c-.641 0-1.158.516-1.158 1.152v3.465c0 .633.518 1.152 1.158 1.152h3.459c.639 0 1.154-.52 1.154-1.152v-3.465c0-.636-.516-1.152-1.154-1.152z"
  }));
};
export default SvgBtnSocialInstagram;